module.exports = __webpack_public_path__ + "static/media/room-feature-balcony.4a730000.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/room-feature-balcony.svg
// module id = 558
// module chunks = 9